var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionFunnelIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#8F93A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.75H19V13.75H21V17.75ZM21 19.75H19V21.75H21V19.75ZM30 11.75V23.75C30 24.2804 29.7893 24.7891 29.4142 25.1642C29.0391 25.5393 28.5304 25.75 28 25.75H14L10 29.75V11.75C10 11.2196 10.2107 10.7109 10.5858 10.3358C10.9609 9.96071 11.4696 9.75 12 9.75H28C28.5304 9.75 29.0391 9.96071 29.4142 10.3358C29.7893 10.7109 30 11.2196 30 11.75ZM28 11.75H12V24.95L13.2 23.75H28V11.75Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFunnelIcon4);
export default __webpack_public_path__ + "static/media/TransactionFunnelIcon4.6de51de0df72b4ca3a67db7cfc58c8b3.svg";
export { ForwardRef as ReactComponent };